import { render, staticRenderFns } from "./OnlinePaymentSetup.vue?vue&type=template&id=7dcccfbd&scoped=true"
import script from "./OnlinePaymentSetup.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcccfbd",
  null
  
)

export default component.exports